import React, { Component } from 'react';

import { Redirect } from 'react-router';

import { Link } from 'react-router-dom';

import '../common/MdPage.css';

import { CalendarDatePicker } from '../common/CalendarDatePicker';

import Select from '../common/AppSelect';

import { findSelectOptionByValue } from '../../services/selectOptions';

import * as constantClass from '../fileWithConstants';

import { ChevronLeftIcon } from '../common/mdPageIcons';

import * as historiaAcademicaService from '../../services/historiaAcademica/historiaAcademicaService';

import {

  classifyHistoriaAcademicaError,

  computeExamenResultadoFromNota,

  EXAMEN_NOTA_OPTIONS,

  formatHistoriaExamenNotaDetailDisplay,

  formatHistoriaExamenResultadoDisplay,

  toUpdateHistoriaAcademicaExamenPayload,

  validateUpdateHistoriaAcademicaExamenForm,

} from '../../services/historiaAcademica/historiaAcademicaDto';

import { displayDate, parseDate } from '../../services/dates/dateService';



export class UpdateHistoriaAcademicaExamen extends Component {

  static displayName = UpdateHistoriaAcademicaExamen.name;



  constructor(props) {

    super(props);

    this.state = {

      loading: false,

      loadingData: true,

      showErrorMessage: false,

      success: false,

      errorMessage: '',

      anio: { anioAcademicoCod: 0, anioAcademicoDescripcion: '', carrera: '' },

      materia: { codigo: 0, anioAcademicoDescripcion: '' },

      id: this.props.match.params.id,

      details: this.props.match.params.details,

      fecha: null,

      nota: '',

      resultado: '',

      valueDictado: null,

    };

  }



  async componentDidMount() {

    const canAccess = await constantClass.canAccess('HistoriaAcademicaExamen');

    if (canAccess) {

      await this.populateData();

    }

  }



  handleConfirmButton = () => {

    const validation = validateUpdateHistoriaAcademicaExamenForm({

      fecha: this.state.fecha,

      nota: this.state.nota,

    });



    if (!validation.valid) {

      this.setState({

        showErrorMessage: true,

        errorMessage: validation.message,

      });

      return;

    }



    this.saveStudent();

  };



  handleHistoriaAcademicaError(error) {

    const outcome = classifyHistoriaAcademicaError(error);

    if (outcome.type === 'timeout') {

      constantClass.RedirectToLogin();

      return { success: false, errorMessage: '' };

    }

    return {

      success: false,

      errorMessage: outcome.message

    };

  }



  async populateData() {

    this.setState({ loadingData: true });

    try {

      const model = await historiaAcademicaService.getHistoriaAcademicaExamen(this.state.id);

      const nota = String(model.historiaAcademicaExamenNota ?? '');

      this.setState({

        loadingData: false,

        errorMessage: '',

        showErrorMessage: false,

        anio: {

          anioAcademicoCod: model.alumnoxCarreraCod,

          anioAcademicoDescripcion: model.alumnoxCarreraCodNavigation.alumnoNombre.trim(),

          carrera: model.alumnoxCarreraCodNavigation.carreraNombre.trim()

        },

        materia: {

          codigo: model.materiaCarreraCod,

          anioAcademicoDescripcion: model.materiaCarreraCodNavigation.materiaCarreraNombre.trim()

        },

        resultado: model.historiaAcademicaExamenResulta.trim(),

        fecha: parseDate(model.historiaAcademicaFechaExamen),

        nota,

        valueDictado: findSelectOptionByValue(EXAMEN_NOTA_OPTIONS, nota),

      });

    } catch (error) {

      const outcome = this.handleHistoriaAcademicaError(error);

      this.setState({

        loadingData: false,

        errorMessage: outcome.errorMessage,

      });

    }

  }



  handleDictadoChangeInput = (option) => {

    const nota = option?.value ?? '';

    this.setState({

      nota,

      valueDictado: option,

      resultado: computeExamenResultadoFromNota(nota),

      showErrorMessage: false,

      errorMessage: '',

    });

  };



  handleFechaExamen = (date) => {

    this.setState({

      fecha: date,

      showErrorMessage: false,

      errorMessage: '',

    });

  };



  render() {

    if (this.state.success) {

      return <Redirect to="/md-hex" />;

    }



    const isDetail = this.state.details !== '0';

    const title = isDetail

      ? 'Detalle de Historia Académica de Examen'

      : 'Modificar Historia Académica de Examen';

    const { loading, loadingData } = this.state;

    const isBusy = loading || loadingData;

    const alumnoDisplay = (`${this.state.anio.anioAcademicoDescripcion} - ${this.state.anio.carrera}`).trim();

    const materiaDisplay = this.state.materia.anioAcademicoDescripcion.trim();

    const resultadoDisplay = formatHistoriaExamenResultadoDisplay(this.state.resultado);



    return (

      <div className="md-page md-update-historia-examen">

        <Link className="md-page__back-link" to="/md-hex">

          <ChevronLeftIcon />

          Volver al listado

        </Link>



        <div className="md-page__header">

          <h1 className="md-page__title">{title}</h1>

        </div>

        <p className="md-page__subtitle">

          {isDetail

            ? 'Consulte los datos registrados de la historia académica de examen.'

            : 'Actualice la fecha, la nota y confirme para guardar los cambios.'}

        </p>



        <div className="md-page__feedback" aria-live="polite" role="status">

          {this.state.showErrorMessage ? (

            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>

          ) : null}

          {this.state.errorMessage && !this.state.showErrorMessage ? (

            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>

          ) : null}

          {loadingData ? (

            <div className="md-page__status">Cargando datos...</div>

          ) : null}

          {loading ? (

            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>

          ) : null}

        </div>



        <div className="md-page__form-card">

          <div className="md-page__field">

            <span className="md-page__field-label">Alumno</span>

            <div className="md-page__field-readonly">{alumnoDisplay || '\u00a0'}</div>

          </div>



          <div className="md-page__field">

            <span className="md-page__field-label">Materia</span>

            <div className="md-page__field-readonly" title={materiaDisplay}>

              {materiaDisplay || '\u00a0'}

            </div>

          </div>



          <div className="md-page__field">

            <span className="md-page__field-label">Fecha de examen</span>

            {isDetail ? (

              <div className="md-page__field-readonly">{displayDate(this.state.fecha) || '\u00a0'}</div>

            ) : (

              <CalendarDatePicker

                className="md-page__field-input"

                selected={this.state.fecha}

                onChange={this.handleFechaExamen}

                disabled={isBusy}

              />

            )}

          </div>



          <div className="md-page__field">

            <span className="md-page__field-label">Nota</span>

            {isDetail ? (

              <div className="md-page__field-readonly">

                {formatHistoriaExamenNotaDetailDisplay(this.state.nota) || '\u00a0'}

              </div>

            ) : (

              <Select

                className="md-page__field-select"

                value={this.state.valueDictado}

                options={EXAMEN_NOTA_OPTIONS}

                placeholder="Seleccioná la nota"

                onChange={this.handleDictadoChangeInput}

                disabled={isBusy}

              />

            )}

          </div>



          <div className="md-page__field">

            <span className="md-page__field-label">Resultado</span>

            <div className="md-page__field-readonly">{resultadoDisplay || '\u00a0'}</div>

          </div>



          {!isDetail ? (

            <div className="md-page__form-actions">

              <button

                type="button"

                className="md-page__form-btn md-page__form-btn--primary"

                onClick={this.handleConfirmButton}

                disabled={isBusy}

              >

                Guardar cambios

              </button>

            </div>

          ) : null}

        </div>

      </div>

    );

  }



  async saveStudent() {

    this.setState({ showErrorMessage: false, loading: true });

    try {

      await historiaAcademicaService.updateHistoriaAcademicaExamen(

        toUpdateHistoriaAcademicaExamenPayload({

          id: this.state.id,

          resultado: this.state.resultado,

          nota: this.state.nota,

          fechaExamen: this.state.fecha

        })

      );

      this.setState({ loading: false, success: true, errorMessage: '' });

    } catch (error) {

      const outcome = this.handleHistoriaAcademicaError(error);

      this.setState({

        loading: false,

        success: false,

        showErrorMessage: true,

        errorMessage: outcome.errorMessage,

      });

    }

  }

}


